var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"sam-image",class:_vm.additionalClass,attrs:{"src":_vm.emptyImage ? require('@/assets/images/product-photo-coming-soon-small.jpg') : _vm.imageUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }